export default class SecurityCodeResponse {
    constructor (json) {
        this.responseCode = json.responseCode
        this.message = json.displayErrorMessage
    }

    success () {
        return this.responseCode === 'SUCCESS'
    }

    message () {
        return this.message
    }
}



// WEBPACK FOOTER //
// ./src/models/responses/SecurityCodeResponse.js